module.exports = __webpack_public_path__ + "static/media/eat-habit-user.9f402849.png";